<section class="users-area">
  <header>
    <h2>{{ 'settingsDialog.userSettingsHeader' | translate }}</h2>
    <p>
      {{ 'settingsDialog.userManagement.line1Description' | translate }}<br />
      {{ 'settingsDialog.userManagement.line2Description' | translate }}
    </p>
  </header>

  <loading-indicator [show]="loading"></loading-indicator>

  <admin-user-management-asa-search-dialog *ngIf="showAsaDialog" (cancel)="asaCancel()" (apply)="asaAddUser($event)"></admin-user-management-asa-search-dialog>

  <div >
    <kendo-grid #kendoGrid [kendoGridBinding]="users"
    [pageSize]="25"
    [pageable]="true"
    [scrollable]="'scrollable'" style="width:100%"
      [filterable]="'menu'"
      (edit)="editHandler($event)"
      (cancel)="cancelHandler($event)"
      (save)="saveHandler($event)"
      (add)="addHandler()">

      <kendo-grid-column field="OID" [title]="'settingsDialog.userManagement.userId' | translate" [width]="60"
        [editable]="false">
      </kendo-grid-column>
      <kendo-grid-column field="User_Lastname" [title]="'settingsDialog.userManagement.userLastname' | translate"
        [width]="200">

      </kendo-grid-column>
      <kendo-grid-column field="User_Firstname" [title]="'settingsDialog.userManagement.userFirstname' | translate"
        [width]="200">

      </kendo-grid-column>
      <kendo-grid-column field="User_Description" [title]="'settingsDialog.userManagement.userDescription' | translate"
        [width]="300">

      </kendo-grid-column>
      <kendo-grid-column field="RTNumber" [title]="'settingsDialog.userManagement.rtNumber' | translate" [width]="150">

      </kendo-grid-column>
      <kendo-grid-column field="UserAcdName" [title]="'settingsDialog.userManagement.userLogin' | translate"
        [width]="200" [hidden]="hideUserAcdNameColumn">

      </kendo-grid-column>
      <kendo-grid-column field="User_Email" [title]="'settingsDialog.userManagement.userUpn' | translate" [width]="200">

      </kendo-grid-column>
      <kendo-grid-column field="User_MailAddress" [title]="'settingsDialog.userManagement.userEMail' | translate"
        [width]="200">

      </kendo-grid-column>
      <kendo-grid-column field="User_Active" [title]="'settingsDialog.userManagement.userActive' | translate"
        [width]="50" editor="boolean">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <input type="checkbox" disabled="disabled" [checked]="dataItem.User_Active" />
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="BusinessUnits" [title]="'settingsDialog.userManagement.userBUs' | translate"
        [width]="250">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div *ngFor="let item of dataItem.BusinessUnitsReal">
            {{ item.displayName }}
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup">
          <kendo-multiselect [formControl]="formGroup.get('BusinessUnitsReal')" [data]="availableBUsReal"
            textField="displayName" valueField="oid" [valuePrimitive]="false">
          </kendo-multiselect>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="BusinessUnitsRole" [title]="'settingsDialog.userManagement.userBURoles' | translate"
        [width]="250">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div *ngFor="let item of dataItem.BusinessUnitsRole">
            {{ item.displayName }}
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup">
          <kendo-multiselect [formControl]="formGroup.get('BusinessUnitsRole')" [data]="availableBUsRole"
            textField="displayName" valueField="oid" [valuePrimitive]="false">
          </kendo-multiselect>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="RoleAssignments" [title]="'settingsDialog.userManagement.role' | translate"
        [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div *ngFor="let item of dataItem.RoleAssignments">
            {{ item.name }}
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup">
          <kendo-multiselect [formControl]="formGroup.get('RoleAssignments')" [data]="availableRoles" textField="name"
            valueField="oid" [valuePrimitive]="false">
          </kendo-multiselect>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="BusinessLineNrId" [title]="'settingsDialog.userManagement.businessLineNr' | translate"
        [width]="150">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div>
            {{ displayDropdownDescription(availableBusinessLineNr, dataItem.BusinessLineNrId) }}
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup">
          <kendo-dropdownlist [formControl]="formGroup.get('BusinessLineNrId')" [data]="availableBusinessLineNr"
            textField="description" valueField="oid" [valuePrimitive]="true">
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="SectorId" [title]="'settingsDialog.userManagement.sector' | translate" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div>
            {{ displayDropdownDescription(availableSectors, dataItem.SectorId) }}
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup">
          <kendo-dropdownlist [formControl]="formGroup.get('SectorId')" [data]="availableSectors"
            textField="description" valueField="oid" [valuePrimitive]="true">
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="RegionsAssignment" [title]="'settingsDialog.userManagement.region' | translate"
        [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div *ngFor="let item of dataItem.RegionsAssignment">
            {{ item.regionDescription }}
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup">
          <kendo-multiselect [formControl]="formGroup.get('RegionsAssignment')" [data]="availableRegions"
            textField="description" valueField="oid" [valuePrimitive]="false">
          </kendo-multiselect>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-column field="OrganizationalRoleId"
        [title]="'settingsDialog.userManagement.organizationalRole' | translate" [width]="200">
        <ng-template kendoGridCellTemplate let-dataItem="dataItem">
          <div>
            {{ displayDropdownDescription(availableOrganizationalRoles, dataItem.OrganizationalRoleId) }}
          </div>
        </ng-template>
        <ng-template kendoGridEditTemplate let-formGroup="formGroup">
          <kendo-dropdownlist [formControl]="formGroup.get('OrganizationalRoleId')"
            [data]="availableOrganizationalRoles" textField="description" valueField="oid" [valuePrimitive]="true">
          </kendo-dropdownlist>
        </ng-template>
      </kendo-grid-column>

      <kendo-grid-command-column [width]="180">
        <ng-template kendoGridCellTemplate let-isNew="isNew">
          <button kendoGridEditCommand [primary]="true">{{ 'common.edit' | translate}}</button>
          <div class="update-cancel-buttons">
            <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
              {{ isNew ? ('common.add' | translate) : ('common.update' | translate) }}
            </button>
            <button kendoGridCancelCommand>
              {{ 'common.cancel' | translate }}
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>

    </kendo-grid>

  </div>
</section>
